import styled from 'styled-components';

import Heading from 'components/_core/Heading';
import Icon from 'components/_core/Icon';
import Text from 'components/_core/Text';

export const UnderReviewTitle = styled(Heading).attrs({
  'aria-level': 1,
  role: 'heading',
  size: 'lg',
})`
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
`;

export const UnderReviewSubTitle = styled(Text).attrs({
  type: 'secondary',
})`
  margin-bottom: ${({ theme }) => theme.spacings.abs48}px;
`;

export const UnderReviewIcon = styled(Icon)`
  margin-right: ${({ theme }) => theme.spacings.abs8}px;
`;

export const UnderReviewCardTop = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 42px 40px 42px;
`;

export const BeneficiarySubTitle = styled(Text).attrs({
  type: 'secondary',
})`
  margin-bottom: ${({ theme }) => theme.spacings.abs32}px;
`;

export const BeneficiaryNextText = styled(Text).attrs({
  type: 'secondary',
})`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs40}px;
`;

export const SectionWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.abs48}px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionTitle = styled(Text).attrs({
  'aria-level': 2,
  fontWeight: 'weight-500',
  role: 'heading',
  size: 'lg',
  variant: 'primary',
})`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs8}px;
`;

export const SectionDescription = styled(Text)`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs24}px;
`;
